const sortObjectEntries = (
  a: [string, unknown],
  b: [string, unknown],
): number => {
  return a[0] > b[0] ? 1 : a[0] < b[0] ? -1 : 0
}

export const arraysAreEqual = (
  a: unknown[],
  b: unknown[],
  deepObjectComparison = false,
): boolean => {
  return (
    a.length === b.length &&
    a.every((x, index) => {
      const y = b[index]

      if (typeof x !== typeof y) {
        return false
      }

      switch (typeof x) {
        case "string":
        case "number":
        case "undefined":
          return x === y
        case "object":
          return deepObjectComparison
            ? objectsAreEqual(x, y)
            : JSON.stringify(x) === JSON.stringify(y)
        default:
          return x === y
      }
    })
  )
}

export const objectsAreEqual = (
  a: Record<string, unknown> | unknown,
  b: Record<string, unknown> | unknown,
  recursive?: boolean,
): boolean => {
  if (a === b) return true

  // Fall back to false if values are not equal but at least one is falsy.
  if (!a || !b) return false

  const entries1 = Object.entries(Object(a)).sort(sortObjectEntries)
  const entries2 = Object.entries(Object(b)).sort(sortObjectEntries)

  return arraysAreEqual(entries1, entries2, Boolean(recursive))
}

export const valuesAreEqual = (a: unknown, b: unknown): boolean => {
  switch (typeof a) {
    case "string":
    case "number":
    case "undefined":
      return a === b
    case "object":
      if (a === null) {
        return b === null
      }

      if (Array.isArray(a)) {
        return Array.isArray(b) ? arraysAreEqual(a, b, true) : false
      }

      return typeof b === "object" && !Array.isArray(b)
        ? objectsAreEqual(a, b, true)
        : false
    default:
      return a === b
  }
}
